import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component"
import { ContractType } from '../../../../models/ContractType';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-contracts-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent
  ],
  templateUrl: './contracts-configuration.component.html',
  styleUrl: './contracts-configuration.component.css'
})
export class ContractsConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Permiso oficial', active: true, type: 'text', key: 'license.name', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 2},
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true, colspan: 2 },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false },

  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', colspan: 2 },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true, colspan: 2 },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'contract-type',
    createButtonTitle: 'Nuevo contrato',
    cols: 2,
    createApiSlug: '/config/contract-type/store',
    formTitle: 'Crear Contrato',
    formButtonTitle: 'Crear Contrato',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'contract-type',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/contract-type/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar el contrato ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/contract-type/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<ContractType>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/contract-type/index',
    paginate: true,
    name: 'contratos',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción' },
    { type: 'multiselect', key: 'license.name', operator: 'in', placeholder: 'Permiso oficial', url: '/config/license/listAll', relation_filter_column: 'license_id' },
    //{type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación'},
  ];

  genericCRUD: GenericCRUD<Paginator<ContractType>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
